// frontend/src/i18n/dwisend.js
// DwiSend Regional — English / French words for the CLIENT-facing parts that
// DRC clients use: the sign-up page and the DwiSend requests page. Not a full
// app translation. Server-side words (notifications, form errors) live in
// services/dwisendI18n.js.
//
// French must be reviewed by a French speaker before DRC goes live (owner
// decision 2026-10-25: Madeleine Tshibem). scripts/dwisend-french-review-sheet.js
// builds the side-by-side review sheet from this file.
//
// {name} placeholders are filled by t(). A missing French entry shows English.

export const MESSAGES = {
  en: {
    // ── Sign-up ──
    'signup.tagline':          'Create Your Free Account',
    'signup.country.title':    'Select Your Country',
    'signup.country.sub':      'Choose the country where your account will be based.',
    'signup.country.required': 'Please select your country',
    'signup.continue':         'Continue →',
    'signup.have_account':     'Already have an account?',
    'signup.sign_in':          'Sign in',
    'signup.title':            'Get started',
    'signup.change':           'Change',
    'signup.name':             'Full Name',
    'signup.email':            'Email',
    'signup.phone':            'Phone Number',
    'signup.password':         'Password',
    'signup.password.ph':      'Minimum 6 characters',
    'signup.password.short':   'Password must be at least 6 characters',
    'signup.referral':         'Referral Code',
    'signup.referral.note':    'You were referred — both you and your friend earn a bonus',
    'signup.submit':           'Create Account',
    'signup.submitting':       'Creating account...',
    'signup.terms':            'By registering you agree to our Terms of Service and Privacy Policy.',
    'signup.failed':           'Registration failed',
    'signup.err.exists':       'Email or phone already registered',
    'signup.err.closed':       'Sign-up is not open in that country yet',

    // ── Requests page ──
    'req.title':               'DwiSend requests',
    'req.subtitle':            'Tell DwiSend what you want to buy. We check it and send you a quote. You pay only after you accept.',
    'req.steps.1':             'Send your request',
    'req.steps.2':             'DwiSend reviews it and sends you a quote',
    'req.steps.3':             'You accept the quote and pay',
    'req.steps.4':             'Two DwiSend staff check your payment',
    'req.steps.5':             'We deliver',
    'req.new':                 '+ New request',
    'req.empty.title':         'No requests yet',
    'req.empty.desc':          'Tell us the product, how much you need, and where to deliver.',
    'req.closed.title':        'DwiSend requests are not open for your account yet',
    'req.closed.desc':         'We will let you know as soon as you can send requests.',
    'req.form.title':          'New request',
    'req.form.product':        'Product',
    'req.form.product.ph':     'e.g. rice, cooking oil, cement, solar panel',
    'req.form.category':       'Category',
    'req.form.unit':           'Unit',
    'req.form.quantity':       'Quantity ({unit})',
    'req.form.target':         'Your target price per {unit} in {currency} (optional)',
    'req.form.target.ph':      'e.g. 42.50',
    'req.form.needed':         'Needed by (optional)',
    'req.form.city':           'City',
    'req.form.city.choose':    '— choose your city —',
    'req.form.no_city':        'No delivery city is open yet. Please check again later.',
    'req.form.address':        'Delivery address',
    'req.form.address.ph':     'Business or name, avenue, number, district, landmark',
    'req.form.phone':          'Phone',
    'req.form.whatsapp':       'WhatsApp (optional, with country code)',
    'req.form.notes':          'Notes (optional)',
    'req.form.notes.ph':       'Brand, quality, packaging, delivery days…',
    'req.form.cancel':         'Cancel',
    'req.form.send':           'Send request',
    'req.form.sent':           'Request sent — DwiSend will reply with a quote',
    'req.status.submitted':        'Request received',
    'req.status.reviewing':        'Under review',
    'req.status.quoted':           'Quote ready',
    'req.status.awaiting_payment': 'Waiting for your payment',
    'req.status.paid':             'Paid — being prepared',
    'req.status.dispatched':       'On its way',
    'req.status.delivered':        'Delivered',
    'req.status.declined':         'Declined',
    'req.status.cancelled':        'Cancelled',
    'req.card.asked':          'requested {date}',
    'req.card.your_price':     'your price {amount} each',
    'req.card.by':             'by {date}',
    'req.card.declined':       'DwiSend cannot supply this request:',
    'req.card.cancel':         'Cancel request',
    'req.card.cancel.confirm': 'Cancel your request for {product}?',
    'req.card.cancelled':      'Request cancelled',
    'req.card.whatsapp':       'WhatsApp DwiSend',
    'req.card.whatsapp.msg':   'Hello DwiSend, about my request {ref} ({product}): ',
    'req.quote.title':         'Quote {ref}',
    'req.quote.status.sent':      'Waiting for your answer',
    'req.quote.status.accepted':  'Accepted',
    'req.quote.status.rejected':  'Refused',
    'req.quote.status.expired':   'Expired',
    'req.quote.delivery':      'Delivery',
    'req.quote.total':         'Total',
    'req.quote.terms':         'Terms:',
    'req.quote.valid':         'Valid until {date}',
    'req.quote.answered':      'Answered {date}',
    'req.quote.accept':        'Accept quote',
    'req.quote.reject':        'Refuse',
    'req.accept.title':        'Accept quote {ref}',
    'req.accept.body':         'By accepting, you agree to pay {amount} to DwiSend. We will show you how to pay. Nothing is taken from you automatically.',
    'req.accept.back':         'Back',
    'req.accept.confirm':      'Accept',
    'req.accept.done':         'Quote accepted — see how to pay below',
    'req.reject.title':        'Refuse quote {ref}',
    'req.reject.why':          'Why? (optional — helps DwiSend send a better offer)',
    'req.reject.why.ph':       'e.g. price too high, need it sooner',
    'req.reject.confirm':      'Refuse',
    'req.reject.done':         'Quote refused — DwiSend has been told',
    'req.pay.title':           'How to pay',
    'req.pay.amount':          'Amount to pay',
    'req.pay.reference':       'Payment reference (write it on your payment)',
    'req.pay.no_details':      'DwiSend will send you the payment details. Please wait before paying.',
    'req.pay.checking':        'Payment received — two DwiSend staff are checking it.',
    'req.pay.waiting_note':    'After you pay, send your receipt to DwiSend. Your request is marked paid only after two DwiSend staff have checked the money arrived.',
    'req.pay.confirmed':       'Payment confirmed.',
    'req.lang':                'Language',
    // ── Shop (2026-10-27) ──
    'shop.nav':                'Shop',
    'shop.title':              'DwiSend shop',
    'shop.subtitle':           'Choose products, send your order, then pay with the order reference. Your order is confirmed once two DwiSend staff have checked your payment.',
    'shop.tab.shop':           'Shop',
    'shop.tab.orders':         'My orders',
    'hub.tab.requests':        'Requests',
    'shop.closed.title':       'The DwiSend shop is not open for your account yet',
    'shop.closed.desc':        'We will let you know as soon as you can order.',
    'shop.empty.title':        'No products yet',
    'shop.empty.desc':         'Products will appear here soon. You can still send a request for what you need.',
    'shop.all':                'All',
    'shop.size':               'Size',
    'shop.in_stock':           '{n} available',
    'shop.out_of_stock':       'Out of stock',
    'shop.min':                'minimum {n}',
    'shop.qty':                'Quantity',
    'shop.add':                'Add to basket',
    'shop.added':              'Added to your basket',
    'shop.brand':              'Brand',
    'shop.origin':             'Origin',
    'shop.warranty':           'Warranty',
    'shop.condition.new':      'New',
    'shop.condition.used':     'Used',
    'shop.condition.refurbished': 'Refurbished',
    'shop.basket':             'Your basket',
    'shop.basket.empty':       'Your basket is empty.',
    'shop.basket.remove':      'Remove',
    'shop.basket.button':      'Basket',
    'shop.each':               '{price} each',
    'shop.qty.less':           'One less',
    'shop.qty.more':           'One more',
    'shop.max_in_basket':      'All {n} available are in your basket',
    'shop.only_available':     'Only {n} available — already in your basket',
    'shop.only_available_short': 'only {n} available',
    'shop.close':              'Close',
    'shop.photo.enlarge':      'Enlarge photo of {name}',
    'shop.photo.prev':         'Previous photo',
    'shop.photo.next':         'Next photo',
    'shop.photo.zoom_in':      'Zoom in',
    'shop.photo.zoom_out':     'Zoom out',
    'shop.cart.updated':       'Your basket was updated:',
    'shop.cart.repriced':      'new price for {names}',
    'shop.cart.reduced':       'less stock for {names}',
    'shop.cart.removed':       '{names} no longer available',
    'shop.cart.check':         'Please check it before ordering.',
    'shop.subtotal':           'Products',
    'shop.delivery':           'Delivery',
    'shop.total':              'Total',
    'shop.checkout':           'Order',
    'shop.checkout.title':     'Delivery and contact',
    'shop.checkout.no_city':   'No delivery city is open yet. Please check again later.',
    'shop.checkout.hold':      'We keep these products for you while DwiSend confirms the delivery fee. Once it is set you have {hours} hours to pay, with your order reference.',
    'shop.checkout.fee_note':  'Delivery is priced per order (weight, town and items): DwiSend will confirm the fee, then you pay products + delivery.',
    'shop.delivery.tbc':       'To be confirmed',
    'shop.total.plus_delivery': '{amount} + delivery',
    'shop.order.fee_pending':  'Delivery fee to be confirmed — DwiSend will contact you. The total to pay will then appear here.',
    'shop.order.held_until':   'Products held until {date}',
    'shop.checkout.confirm':   'Send my order',
    'shop.checkout.done':      'Order sent — see below how to pay',
    'shop.min_order':          'Minimum order: {amount}',
    'shop.order.title':        'Order {ref}',
    'shop.order.placed':       'ordered {date}',
    'shop.order.pay_by':       'Pay before {date}',
    'shop.order.cancel':       'Cancel order',
    'shop.order.cancel.confirm': 'Cancel order {ref}? The products go back on sale.',
    'shop.order.cancelled':    'Order cancelled',
    'shop.order.cancel_reason':'Cancelled by DwiSend:',
    'shop.order.driver':       'Delivery by {name}',
    'shop.order.whatsapp.msg': 'Hello DwiSend, about my order {ref}: ',
    'shop.orders.empty':       'No orders yet',
    'shop.status.awaiting_payment': 'Waiting for your payment',
    'shop.status.paid':        'Paid — being prepared',
    'shop.status.dispatched':  'On its way',
    'shop.status.delivered':   'Delivered',
    'shop.status.cancelled':   'Cancelled',
    'shop.status.expired':     'Closed — not paid in time',
    'shop.pay.waiting_note':   'After you pay, send your receipt to DwiSend. Your order is marked paid only after two DwiSend staff have checked the money arrived. If it is not paid in time, the order closes and the products go back on sale.',
  },
  fr: {
    'signup.tagline':          'Créez votre compte gratuit',
    'signup.country.title':    'Choisissez votre pays',
    'signup.country.sub':      'Choisissez le pays où votre compte sera basé.',
    'signup.country.required': 'Veuillez choisir votre pays',
    'signup.continue':         'Continuer →',
    'signup.have_account':     'Vous avez déjà un compte ?',
    'signup.sign_in':          'Se connecter',
    'signup.title':            'Commencer',
    'signup.change':           'Modifier',
    'signup.name':             'Nom complet',
    'signup.email':            'E-mail',
    'signup.phone':            'Numéro de téléphone',
    'signup.password':         'Mot de passe',
    'signup.password.ph':      'Au moins 6 caractères',
    'signup.password.short':   'Le mot de passe doit contenir au moins 6 caractères',
    'signup.referral':         'Code de parrainage',
    'signup.referral.note':    'Vous avez été parrainé — vous et votre ami recevez un bonus',
    'signup.submit':           'Créer mon compte',
    'signup.submitting':       'Création du compte...',
    'signup.terms':            'En vous inscrivant, vous acceptez nos Conditions d\'utilisation et notre Politique de confidentialité.',
    'signup.failed':           'L\'inscription a échoué',
    'signup.err.exists':       'Cet e-mail ou ce numéro de téléphone est déjà enregistré',
    'signup.err.closed':       'L\'inscription n\'est pas encore ouverte dans ce pays',

    'req.title':               'Demandes DwiSend',
    'req.subtitle':            'Dites à DwiSend ce que vous voulez acheter. Nous l\'examinons et vous envoyons un devis. Vous ne payez qu\'après l\'avoir accepté.',
    'req.steps.1':             'Envoyez votre demande',
    'req.steps.2':             'DwiSend l\'examine et vous envoie un devis',
    'req.steps.3':             'Vous acceptez le devis et payez',
    'req.steps.4':             'Deux membres de l\'équipe DwiSend vérifient votre paiement',
    'req.steps.5':             'Nous livrons',
    'req.new':                 '+ Nouvelle demande',
    'req.empty.title':         'Aucune demande pour le moment',
    'req.empty.desc':          'Indiquez-nous le produit, la quantité souhaitée et le lieu de livraison.',
    'req.closed.title':        'Les demandes DwiSend ne sont pas encore ouvertes pour votre compte',
    'req.closed.desc':         'Nous vous préviendrons dès que vous pourrez envoyer des demandes.',
    'req.form.title':          'Nouvelle demande',
    'req.form.product':        'Produit',
    'req.form.product.ph':     'ex. riz, huile de cuisine, ciment, panneau solaire',
    'req.form.category':       'Catégorie',
    'req.form.unit':           'Unité',
    'req.form.quantity':       'Quantité ({unit})',
    'req.form.target':         'Votre prix souhaité par {unit} en {currency} (facultatif)',
    'req.form.target.ph':      'ex. 42,50',
    'req.form.needed':         'Pour le (facultatif)',
    'req.form.city':           'Ville',
    'req.form.city.choose':    '— choisissez votre ville —',
    'req.form.no_city':        'Aucune ville de livraison n\'est encore ouverte. Veuillez réessayer plus tard.',
    'req.form.address':        'Adresse de livraison',
    'req.form.address.ph':     'Entreprise ou nom, avenue, numéro, quartier, repère',
    'req.form.phone':          'Téléphone',
    'req.form.whatsapp':       'WhatsApp (facultatif, avec l\'indicatif du pays)',
    'req.form.notes':          'Remarques (facultatif)',
    'req.form.notes.ph':       'Marque, qualité, emballage, jours de livraison…',
    'req.form.cancel':         'Annuler',
    'req.form.send':           'Envoyer la demande',
    'req.form.sent':           'Demande envoyée — DwiSend vous répondra avec un devis',
    'req.status.submitted':        'Demande reçue',
    'req.status.reviewing':        'En cours d\'examen',
    'req.status.quoted':           'Devis disponible',
    'req.status.awaiting_payment': 'En attente de votre paiement',
    'req.status.paid':             'Payé — en préparation',
    'req.status.dispatched':       'En route',
    'req.status.delivered':        'Livré',
    'req.status.declined':         'Refusée',
    'req.status.cancelled':        'Annulée',
    'req.card.asked':          'demandé le {date}',
    'req.card.your_price':     'votre prix : {amount} l\'unité',
    'req.card.by':             'pour le {date}',
    'req.card.declined':       'DwiSend ne peut pas fournir cette demande :',
    'req.card.cancel':         'Annuler la demande',
    'req.card.cancel.confirm': 'Annuler votre demande pour {product} ?',
    'req.card.cancelled':      'Demande annulée',
    'req.card.whatsapp':       'WhatsApp DwiSend',
    'req.card.whatsapp.msg':   'Bonjour DwiSend, au sujet de ma demande {ref} ({product}) : ',
    'req.quote.title':         'Devis {ref}',
    'req.quote.status.sent':      'En attente de votre réponse',
    'req.quote.status.accepted':  'Accepté',
    'req.quote.status.rejected':  'Refusé',
    'req.quote.status.expired':   'Expiré',
    'req.quote.delivery':      'Livraison',
    'req.quote.total':         'Total',
    'req.quote.terms':         'Conditions :',
    'req.quote.valid':         'Valable jusqu\'au {date}',
    'req.quote.answered':      'Répondu le {date}',
    'req.quote.accept':        'Accepter le devis',
    'req.quote.reject':        'Refuser',
    'req.accept.title':        'Accepter le devis {ref}',
    'req.accept.body':         'En acceptant, vous vous engagez à payer {amount} à DwiSend. Nous vous indiquerons comment payer. Rien n\'est prélevé automatiquement.',
    'req.accept.back':         'Retour',
    'req.accept.confirm':      'Accepter',
    'req.accept.done':         'Devis accepté — voyez ci-dessous comment payer',
    'req.reject.title':        'Refuser le devis {ref}',
    'req.reject.why':          'Pourquoi ? (facultatif — cela aide DwiSend à vous faire une meilleure offre)',
    'req.reject.why.ph':       'ex. prix trop élevé, besoin plus tôt',
    'req.reject.confirm':      'Refuser',
    'req.reject.done':         'Devis refusé — DwiSend a été informé',
    'req.pay.title':           'Comment payer',
    'req.pay.amount':          'Montant à payer',
    'req.pay.reference':       'Référence de paiement (indiquez-la sur votre paiement)',
    'req.pay.no_details':      'DwiSend vous enverra les coordonnées de paiement. Veuillez attendre avant de payer.',
    'req.pay.checking':        'Paiement reçu — deux membres de l\'équipe DwiSend le vérifient.',
    'req.pay.waiting_note':    'Après avoir payé, envoyez votre reçu à DwiSend. Votre demande n\'est marquée payée qu\'après que deux membres de l\'équipe DwiSend ont vérifié la réception de l\'argent.',
    'req.pay.confirmed':       'Paiement confirmé.',
    'req.lang':                'Langue',
    // ── Boutique (2026-10-27) ──
    'shop.nav':                'Boutique',
    'shop.title':              'Boutique DwiSend',
    'shop.subtitle':           'Choisissez vos produits, envoyez votre commande, puis payez avec la référence de commande. Votre commande est confirmée dès que deux membres de l\'équipe DwiSend ont vérifié votre paiement.',
    'shop.tab.shop':           'Boutique',
    'shop.tab.orders':         'Mes commandes',
    'hub.tab.requests':        'Demandes',
    'shop.closed.title':       'La boutique DwiSend n\'est pas encore ouverte pour votre compte',
    'shop.closed.desc':        'Nous vous préviendrons dès que vous pourrez commander.',
    'shop.empty.title':        'Aucun produit pour le moment',
    'shop.empty.desc':         'Les produits apparaîtront ici bientôt. Vous pouvez toujours envoyer une demande pour ce dont vous avez besoin.',
    'shop.all':                'Tout',
    'shop.size':               'Format',
    'shop.in_stock':           '{n} disponible(s)',
    'shop.out_of_stock':       'Rupture de stock',
    'shop.min':                'minimum {n}',
    'shop.qty':                'Quantité',
    'shop.add':                'Ajouter au panier',
    'shop.added':              'Ajouté à votre panier',
    'shop.brand':              'Marque',
    'shop.origin':             'Origine',
    'shop.warranty':           'Garantie',
    'shop.condition.new':      'Neuf',
    'shop.condition.used':     'Occasion',
    'shop.condition.refurbished': 'Reconditionné',
    'shop.basket':             'Votre panier',
    'shop.basket.empty':       'Votre panier est vide.',
    'shop.basket.remove':      'Retirer',
    'shop.basket.button':      'Panier',
    'shop.each':               '{price} l\'unité',
    'shop.qty.less':           'Un de moins',
    'shop.qty.more':           'Un de plus',
    'shop.max_in_basket':      'Les {n} disponibles sont dans votre panier',
    'shop.only_available':     'Seulement {n} disponible(s) — déjà dans votre panier',
    'shop.only_available_short': 'seulement {n} disponible(s)',
    'shop.close':              'Fermer',
    'shop.photo.enlarge':      'Agrandir la photo de {name}',
    'shop.photo.prev':         'Photo précédente',
    'shop.photo.next':         'Photo suivante',
    'shop.photo.zoom_in':      'Zoomer',
    'shop.photo.zoom_out':     'Dézoomer',
    'shop.cart.updated':       'Votre panier a été mis à jour :',
    'shop.cart.repriced':      'nouveau prix pour {names}',
    'shop.cart.reduced':       'moins de stock pour {names}',
    'shop.cart.removed':       '{names} n\'est plus disponible',
    'shop.cart.check':         'Vérifiez-le avant de commander.',
    'shop.subtotal':           'Produits',
    'shop.delivery':           'Livraison',
    'shop.total':              'Total',
    'shop.checkout':           'Commander',
    'shop.checkout.title':     'Livraison et contact',
    'shop.checkout.no_city':   'Aucune ville de livraison n\'est encore ouverte. Veuillez réessayer plus tard.',
    'shop.checkout.hold':      'Nous vous réservons ces produits pendant que DwiSend confirme les frais de livraison. Une fois fixés, vous avez {hours} heures pour payer, avec votre référence de commande.',
    'shop.checkout.fee_note':  'La livraison est calculée par commande (poids, ville et articles) : DwiSend vous confirmera les frais, puis vous paierez produits + livraison.',
    'shop.delivery.tbc':       'À confirmer',
    'shop.total.plus_delivery': '{amount} + livraison',
    'shop.order.fee_pending':  'Frais de livraison à confirmer — DwiSend va vous contacter. Le total à payer s\'affichera ensuite ici.',
    'shop.order.held_until':   'Produits réservés jusqu\'au {date}',
    'shop.checkout.confirm':   'Envoyer ma commande',
    'shop.checkout.done':      'Commande envoyée — voyez ci-dessous comment payer',
    'shop.min_order':          'Commande minimum : {amount}',
    'shop.order.title':        'Commande {ref}',
    'shop.order.placed':       'commandé le {date}',
    'shop.order.pay_by':       'Payer avant le {date}',
    'shop.order.cancel':       'Annuler la commande',
    'shop.order.cancel.confirm': 'Annuler la commande {ref} ? Les produits seront remis en vente.',
    'shop.order.cancelled':    'Commande annulée',
    'shop.order.cancel_reason':'Annulée par DwiSend :',
    'shop.order.driver':       'Livraison par {name}',
    'shop.order.whatsapp.msg': 'Bonjour DwiSend, au sujet de ma commande {ref} : ',
    'shop.orders.empty':       'Aucune commande pour le moment',
    'shop.status.awaiting_payment': 'En attente de votre paiement',
    'shop.status.paid':        'Payée — en préparation',
    'shop.status.dispatched':  'En route',
    'shop.status.delivered':   'Livrée',
    'shop.status.cancelled':   'Annulée',
    'shop.status.expired':     'Fermée — non payée à temps',
    'shop.pay.waiting_note':   'Après avoir payé, envoyez votre reçu à DwiSend. Votre commande n\'est marquée payée qu\'après que deux membres de l\'équipe DwiSend ont vérifié la réception de l\'argent. Si elle n\'est pas payée à temps, la commande est fermée et les produits sont remis en vente.',
  },
};

export const LANGS = ['en', 'fr'];

export function t(lang, key, vars = {}) {
  const s = (MESSAGES[lang] && MESSAGES[lang][key]) || MESSAGES.en[key] || key;
  return s.replace(/\{(\w+)\}/g, (m, k) => (vars[k] !== undefined && vars[k] !== null ? String(vars[k]) : m));
}

// "USD 12.50" / "12,50 USD" from whole cents.
export function money(minor, currency, lang) {
  const n = new Intl.NumberFormat(lang === 'fr' ? 'fr-FR' : 'en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .format(Number(minor || 0) / 100);
  return lang === 'fr' ? `${n} ${currency}` : `${currency} ${n}`;
}

// Grams → "1 250 kg" / "2,15 t" (fr), "1,250 kg" / "2.15 t" (en).
export function weight(grams, lang) {
  const kg = Number(grams || 0) / 1000;
  const loc = lang === 'fr' ? 'fr-FR' : 'en-US';
  return kg >= 1000 ? `${new Intl.NumberFormat(loc, { maximumFractionDigits: 2 }).format(kg / 1000)} t`
    : `${new Intl.NumberFormat(loc, { maximumFractionDigits: 3 }).format(kg)} kg`;
}

export const dateTime = (d, lang) => (d ? new Date(d).toLocaleString(lang === 'fr' ? 'fr-FR' : 'en-GB', { day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit' }) : '');

export const date = (d, lang) => (d ? new Date(d).toLocaleDateString(lang === 'fr' ? 'fr-FR' : 'en-GB', { day: 'numeric', month: 'long', year: 'numeric' }) : '');

// Default: the account's chosen language, else French for DRC, else English.
export const langFor = user => (LANGS.includes(user?.language) ? user.language : user?.countryCode === 'CD' ? 'fr' : 'en');
